import { render, staticRenderFns } from "./IconLang.vue?vue&type=template&id=7494e332&scoped=true&"
import script from "./IconLang.vue?vue&type=script&lang=js&"
export * from "./IconLang.vue?vue&type=script&lang=js&"
import style0 from "./IconLang.vue?vue&type=style&index=0&id=7494e332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494e332",
  null
  
)

export default component.exports